// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'font-awesome/css/font-awesome.css'

// import jQuery from 'jquery'

// import 'bootstrap/dist/js/bootstrap.js'

import 'bootstrap'
import 'admin-lte'
import 'jquery'
import 'icheck'
import moment from 'moment'

import '../node_modules/bootstrap/dist/css/bootstrap.css'
import './assets/skin-blue.less'
import './assets/AdminLTE.less'

import '../node_modules/daterangepicker/daterangepicker'
import '../node_modules/daterangepicker/daterangepicker.css'

import store from './store'
import router from './router'

import Vue from 'vue'
import App from './App.vue';
// import BootstrapVue from 'bootstrap-vue'
import vSelect from 'vue-select/dist/vue-select'

import {ServerTable} from 'vue-tables-2';
import Toastr from 'vue-toastr';
import 'vue-toastr/src/vue-toastr.scss'
import VuePassword from 'vue-password'
import {messages} from './locales'
import VueSentry from 'vue2-sentry'
import vbclass from 'vue-body-class'
import Security from './mixin/Security'
import Translate from './mixin/Translate'
import VueI18n from 'vue-i18n'
// import * as VueGoogleMaps from 'vue2-google-maps'
// import Geocoder from './geocoder';

Vue.use( vbclass, router )

// window.jQuery = jQuery
window.$ = jQuery
window.moment = moment

$(document).on('click', '.sidebar-toggle', function () {
  if ($('body').hasClass("sidebar-collapse") && $('body').hasClass("sidebar-open")) {
    $('body').removeClass("sidebar-collapse");
  }
});

Vue.use(VueI18n)
Vue.use(Toastr)
Vue.use(ServerTable, {}, false, 'bootstrap4', 'default');
// Vue.use(VueGoogleMaps, {load: {key: process.env.GOOGLE_API_KEY}})
// Vue.use(Geocoder, {googleMapsApiKey: process.env.GOOGLE_API_KEY});
// Vue.use(BootstrapVue);

Vue.component('v-select', vSelect)
Vue.component(VuePassword)

Vue.use(VueSentry, {
  enable: process.env.NODE_ENV === 'production',
  key: process.env.SENTRY_PUBLIC_KEY,
  project: process.env.SENTRY_PROJECT_ID,
  server: process.env.SENTRY_SERVER,
  protocol: process.env.SENTRY_PROTOCOL,
  config: {}
})

let i18n = new VueI18n({
  locale: store.state.auth.language,
  messages
})

$(function () {
  $('input').iCheck({
    checkboxClass: 'icheckbox_square-blue',
    radioClass: 'iradio_square-blue',
    increaseArea: '20%' /* optional */
  });
});

Vue.mixin(Security)
Vue.mixin(Translate)

new Vue({
  el: '#app',
  store,
  router,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js